import { render, staticRenderFns } from "./update-status-sue-saparate-namkambangkab.vue?vue&type=template&id=e0561b12&"
import script from "./update-status-sue-saparate-namkambangkab.vue?vue&type=script&lang=js&"
export * from "./update-status-sue-saparate-namkambangkab.vue?vue&type=script&lang=js&"
import style0 from "./update-status-sue-saparate-namkambangkab.vue?vue&type=style&index=0&id=e0561b12&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports